import React from 'react';

const PALETTE = ['#6366f1', '#0ea5e9', '#f59e0b', '#ec4899', '#14b8a6', '#8b5cf6', '#f43f5e', '#22c55e'];

function hashColor(str) {
  let hash = 0;
  for (let i = 0; i < (str || '').length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase();
}

export default function Avatar({ name, size = 22 }) {
  if (!name) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: size, height: size, borderRadius: '50%', background: '#e2e8f0', color: '#94a3b8',
        fontSize: size * 0.42, fontWeight: '700', flexShrink: 0,
      }}>?</span>
    );
  }
  return (
    <span title={name} style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, borderRadius: '50%', background: hashColor(name), color: '#fff',
      fontSize: size * 0.42, fontWeight: '700', flexShrink: 0, letterSpacing: '-0.02em',
    }}>{initials(name)}</span>
  );
}
